import { QueueUtil } from './QueueUtils';
import { TypeUtils } from './TypeUtils';
import { StringUtils } from './StringUtils';
import {
  TabManagementUtil,
  FormTabManagementUtil,
  ensureTabManagement,
  ensureFormTabManagement,
} from './TabManagementUtil';
import { ClientEventUtils } from './ClientEventUtils';
import { PageDataHelpers } from '../components/page/utils/PageDataUtils';
import { DOMHelpers } from '../utils/DomUtils';
import { eventsHub } from './EventsHub';
import { TranslationHelpers } from 'utils/TranslationUtils';
import { ImageUtils } from 'utils/ImageUtils';
import { NotificationUtils } from 'domains/portal/Notifications/NotificationUtils';
import { RuleActionUtils } from 'domains/designers/RuleDesigner/RuleActionUtils';
import * as ActionUtils from 'utils/ActionUtils';
import { ReportGridStoreUtils } from './ReportGridStoreUtils';
import { isDisplayTypeTablet, isDisplayTypeMobile } from 'utils/ApiUtils';
import { TruthTableUtils } from 'domains/designers/TruthTable/TruthTableUtils';
import * as ErrorUtils from './ErrorUtils';
import { FormUtils } from 'domains/designers/forms/composite-controls/utils/FormUtils';
import { GuidUtils } from 'utils/Guid';
/**
 * Because this is consumed by some namespace based TS, we need a "namespace" way to
 * refer to these Utilities, so we are encapsulating them in this object:
 */
export const Utils = {
  Type: TypeUtils,
  String: StringUtils,
  TabManagementUtil,
  ensureTabManagement,
  ensureFormTabManagement,
  FormTabManagementUtil,
  ClientEventUtils,
  PageDataHelpers,
  DOMHelpers,
  QueueUtil: QueueUtil,
  EventsHub: eventsHub,
  TranslationHelpers,
  ImageUtils,
  NotificationUtils,
  ActionUtils,
  RuleActionUtils,
  ReportGridStoreUtils,
  Display: {
    isDisplayTypeTablet,
    isDisplayTypeMobile,
  },
  TruthTable: TruthTableUtils,
  ErrorUtils,
  FormUtils,
  GuidUtils,
};
